import type { Directive } from "vue";
import { nextTick } from "vue";

// Small shared state to let other components know if autofocus is pending
export const autofocusStatus: { pending: boolean } = { pending: false };

/**
 * Autofocuses to the element on mount and sets tabindex=0
 * To autofocus later/conditionally, pass a value of false
 *
 * @param value if false, autofocus will not initialize (note: with any other value, including undefined, it will initialize)
 */
export function autofocus(): Directive<HTMLElement, boolean | undefined> {
  /**
   * Focus on the element and give it a tabindex if necessary
   */
  const initAutofocus = (el: HTMLElement) => {
    autofocusStatus.pending = true;
    void nextTick(() => {
      if (el.nodeName === "LABEL") {
        el.click();
      } else {
        el.tabIndex = el.tabIndex ?? 0;
        el.focus();
      }
      autofocusStatus.pending = false;
    });
  };

  return {
    mounted(el, { value }) {
      if (value === false) {
        return;
      }

      initAutofocus(el);
    },

    updated(el, { value, oldValue }) {
      if (oldValue === false && value !== false) {
        initAutofocus(el);
      }
    },
  };
}
